import { connect } from 'formik'
import { get, has, startCase } from 'lodash'

import FileUpload from '@/components/GenericForm/FileUpload'
import Listbox from '@/components/GenericForm/ListBox'
import Checkbox from '@/components/TailwindUI/Checkbox'
import TextInput from '@/components/TailwindUI/TextInput'
import Toggle from '@/components/TailwindUI/Toggle'
import ValidationMessage from '@/components/TailwindUI/ValidationMessage'

const AppConfigInstallFormField = ({
  formikName,
  config: { defaultValue, description, formInputType, name, allowedValues, required, placeholder, displayName },
  formik: { errors, setFieldValue, touched }
}: any) => {
  const renderFormControl = () => {
    switch (formInputType) {
      case 'url':
      case 'text':
      case 'email':
      case 'number': {
        return (
          <div key={name}>
            <TextInput
              boldHeaders={true}
              label={displayName ?? startCase(name)}
              required={required}
              error={
                has(touched, `${formikName}.defaultValue`) && has(errors, `${formikName}.defaultValue`)
                  ? get(errors, `${formikName}.defaultValue`)
                  : ''
              }
              description={description}
              placeholder={placeholder ?? `Enter ${startCase(name)} value `}
              type={formInputType}
              name={name}
              value={defaultValue}
              onChange={e => setFieldValue(`${formikName}.defaultValue`, e.target.value)}
            />
          </div>
        )
      }
      case 'checkbox': {
        return (
          <Checkbox
            onChange={() => setFieldValue(`${formikName}.defaultValue`, !defaultValue)}
            description={description}
            boldHeaders={true}
            checked={defaultValue}
            label={displayName ?? startCase(name)}
          />
        )
      }
      case 'toggle': {
        return (
          <Toggle
            onChange={() => setFieldValue(`${formikName}.defaultValue`, !defaultValue)}
            boldHeaders={true}
            description={description}
            checked={defaultValue}
            label={displayName ?? startCase(name)}
          />
        )
      }
      case 'select': {
        return (
          <Listbox
            name={formikName}
            options={[{ label: `Select an option`, value: '' }].concat(
              allowedValues?.split(',')?.map((allowedValue: string) => ({ label: allowedValue, value: allowedValue }))
            )}
            error={
              has(touched, `${formikName}.defaultValue`) && has(errors, `${formikName}.defaultValue`)
                ? get(errors, `${formikName}.defaultValue`)
                : ''
            }
            value={defaultValue}
            onChange={({ value }) => setFieldValue(`${formikName}.defaultValue`, value)}
            boldHeaders={true}
            description={description}
            label={displayName ?? startCase(name)}
          />
        )
      }
      case 'file-upload': {
        return (
          <div>
            <FileUpload
              formatProps={{
                name: `${formikName}.defaultValue`,
                label: displayName ?? startCase(name),
                required: required,
                error:
                  has(touched, `${formikName}.defaultValue`) && has(errors, `${formikName}.defaultValue`)
                    ? get(errors, `${formikName}.defaultValue`)
                    : ''
              }}
              accept={['.pdf', '.csv', '.txt']}
              value={defaultValue}
              onChange={value => setFieldValue(`${formikName}.defaultValue`, value)}
            />
            <ValidationMessage>
              {has(touched, `${formikName}.defaultValue`) && has(errors, `${formikName}.defaultValue.name`)
                ? get(errors, `${formikName}.defaultValue.name`)
                : ''}
            </ValidationMessage>
          </div>
        )
      }
      default: {
        return null
      }
    }
  }

  return renderFormControl()
}

export default connect(AppConfigInstallFormField)
